import styled from 'styled-components';
import { useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { device, shadows } from '../../utils/styled-component-mixins';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { withLocalization } from '../shared/Context/LocalizationContext';
import { useLocalization } from '../custom-hooks/useLocalization';
import ButtonLink from '../shared/ButtonLinkComponent';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';
import { compose } from '../utils/compose';

const ExpandableSidebarComponentStyled = styled.aside`
  ${shadows.cardShadow};
  background-color: var(--white);
  padding: 4rem 1.6rem 3.5rem 1.6rem;

  @media ${device.desktop} {
    padding: 4rem;
  }

  h2 {
    font-size: 2.2rem;
    font-weight: 800;
    line-height: 3.2rem;
  }

  .btn-wrapper {
    margin-top: 2rem;

    span {
      &:first-child {
        font-size: 1.4rem;
        line-height: 1.8rem;
      }
    }

    .material-icons-round {
      border-bottom: 2px solid transparent;
      font-size: 1.8rem;
      margin-left: 0.5rem;
    }
  }

  .expanded-content {
    p {
      margin: 0;
      padding: 1.6rem 0;
    }
  }
`;

const ExpandableSidebarComponent = (props) => {
  const { heading, widgetID } = props.properties;
  const { resourceStrings } = useLocalization();
  const [description, setDescription] = useState('');
  const [expandedContent, setExpandedContent] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  const expandButtonText = resourceStrings.expandableSidebarExpandButtonText;
  const collapseButtonText = resourceStrings.expandableSidebarCollapseButtonText;

  useEffect(() => {
    setDescription(props.properties.description);
    setExpandedContent(props.properties.expandedContent);
  }, [props.properties.description, props.properties.expandedContent]);

  return (
    <WidgetIdWrapper widgetID={widgetID}>
      <ExpandableSidebarComponentStyled>
        <div>
          <h2>{heading}</h2>
          <p dangerouslySetInnerHTML={{ __html: description }}></p>
        </div>
        <AnimateHeight duration={500} height={isExpanded ? 'auto' : 0}>
          <div
            className="expanded-content"
            dangerouslySetInnerHTML={{ __html: expandedContent }}
          ></div>
        </AnimateHeight>
        {expandedContent && (
          <ButtonLink
            isButtonTag={true}
            type="tertiary"
            text={isExpanded ? collapseButtonText : expandButtonText}
            replacementTertiaryIcon={isExpanded ? 'remove' : 'add'}
            theme="light"
            onClickFunction={() => setIsExpanded(!isExpanded)}
          />
        )}
      </ExpandableSidebarComponentStyled>
    </WidgetIdWrapper>
  );
};

export default compose(withLocalization, withWidgetSpacingWrapper)(ExpandableSidebarComponent);
